import React from 'react';
import PropTypes from 'prop-types';
import { css } from '@emotion/core';
import { ReactComponent as CoverBgSVG01 } from 'assets/icon/cover_background_01.svg';

export const SVG_TYPES = {
    COVER_01: 'COVER_BG_01'
};

const CoverBgSVG = ({ type, bgColor, customStyle }) => {
    const getSVGContent = () => {
        switch (type) {
            case SVG_TYPES.COVER_01:
                return <CoverBgSVG01 css={[baseSVGStyle(bgColor), customStyle]} />;
            default:
                return null;
        }
    };

    return getSVGContent();
};

export default CoverBgSVG;

CoverBgSVG.propTypes = {
    type: PropTypes.string.isRequired,
    bgColor: PropTypes.string.isRequired,
    customStyle: PropTypes.object
};

const baseSVGStyle = backgroundColor => css`
    .s0 {
        fill: ${backgroundColor};
    }
    position: absolute;
`;
